<template>

    <div v-show="true" class="w-full flex flex-col">
      <div class="flex">
        <div class="mr-4">
          <vue-ctk-date-time-picker
            v-model="dateRangeFrom"
            :no-value-to-custom-elem="true"
            input-size="sm"
            format="YYYY-MM-DD HH:mm"
            formatted="YYYY-MM-DD HH:mm"
            label="Select from time"
            button-now-translation="Now"
            color="#7fa99b"
            :no-clear-button="true"
            :no-header="true"
          >
            <l-input v-model="dateRangeFrom" type="text" placeholder>
              <template slot="prefix">
                <font-awesome-icon icon="clock" class="text-base text-gray-500" />
              </template>
            </l-input>
          </vue-ctk-date-time-picker>
        </div>
        <div class="mr-4">
          <vue-ctk-date-time-picker
            v-model="dateRangeTo"
            :no-value-to-custom-elem="true"
            input-size="sm"
            format="YYYY-MM-DD HH:mm"
            formatted="YYYY-MM-DD HH:mm"
            label="Select to time"
            button-now-translation="Now"
            color="#7fa99b"
            :no-clear-button="true"
            :no-header="true"
            :min-date="dateRangeFrom"
            :max-date="maxDate"
          >
            <l-input v-model="dateRangeTo" type="text" placeholder>
              <template slot="prefix">
                <font-awesome-icon icon="clock" class="text-base text-gray-500" />
              </template>
            </l-input>
          </vue-ctk-date-time-picker>
        </div>
      </div>

      <div class="flex mt-4">    
        <div class="text-center px-4 py-2 m-2"><l-button :id="'daterange'" :type="getType('daterange')" @click="onClick"> {{$t('viewtimeseries')}}</l-button></div>
        <div class="text-center px-4 py-2 m-2"><l-button :id="'last24h'" :type="getType('last24h')" @click="onClick">{{$t('last24h')}}</l-button></div>
<!--         <div class="text-center px-4 py-2 m-2"><l-button :id="'olddata'" :type="getType('olddata')" @click="onClick">{{$t('olddata')}}</l-button></div> -->
        <div class="text-center px-4 py-2 m-2"><l-button :id="'newdata'" :type="getType('newdata')" @click="onClick">{{$t('newdata')}}</l-button></div>
      </div>
    </div>

</template>

<script>

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import * as moment from "moment";
import { LSelect, LOption, LButton, LInput, LCheckbox } from "@/components/forms";
export default {
  name: "LLSelection",
  components: {
    LInput,
    LSelect,
    LOption,
    LButton,
    LCheckbox,
    VueCtkDateTimePicker
  },

  data() {
    return {
      dateRangeFrom: moment().subtract(24,"hours").format("YYYY-MM-DD HH:mm"), // moment().add(-1, "months").format("YYYY-MM-DD HH:mm"),
      dateRangeTo: moment().format("YYYY-MM-DD HH:mm"),  //moment().add(1, "days").format("YYYY-MM-DD HH:mm"),
      //FilteringOptions,
      filtering: this.$parent.FilteringOptions.last24h,
    };
  },
  computed: {
  },
  methods: {
    getType(btn){
        return btn === this.filtering ? 'warning' : 'success';
    },
    onClick : function(id) { 
      this.filtering = id;

      if(id === this.$parent.FilteringOptions.last24h){
        this.dateRangeFrom = moment().subtract(24,"hours").format("YYYY-MM-DD HH:mm"); 
        this.dateRangeTo = moment().format("YYYY-MM-DD HH:mm");;
      }

      this.$emit("click", {
        from: moment(this.dateRangeFrom).utc().unix(),
        to: moment(this.dateRangeTo).utc().unix(),
        filtering : this.filtering
      });
    }
  },
  computed: {
    startDate() {
      const start = moment().subtract(2, 'month');
      return start.format('YYYY-MM-DDTHH:mm:ss');
    },
    maxDate() {
      const max = moment(this.dateRangeFrom).add(2, 'month');
      return max.format('YYYY-MM-DDTHH:mm:ss');
    }, 
  }
};
</script>
